import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
const ROOT_CSS_CLASS = 'spa-pagination';

const DEFAULTS = {
  pagination: {
    id: null,
    domContainer: null,
    callback: null,
    align: 'right',
    style: 'none', 
    size: 25,
    sizeList: [10, 25, 50, 100],
    index: 0,
    length: 0,
    totalRecords: 0,
    title: null,
    allowPageSizeChange: true,
  },
};

const paginationEventsClassList = [
  `${ROOT_CSS_CLASS}-btn--previous`,
  `${ROOT_CSS_CLASS}-btn--next`,
  `${ROOT_CSS_CLASS}-btn--first`,
  `${ROOT_CSS_CLASS}-btn--last`,
  `${ROOT_CSS_CLASS}-page-size`,
  `${ROOT_CSS_CLASS}-page-list`,
  `${ROOT_CSS_CLASS}-btn--load-more`,
];





function getPaginationJcr() {
  if (window.globalParams) {
    return window.globalParams.pagination;
  }

  if (!window.spaParams) {
    return {};
  }

  const lang = window.sparta ? window.sparta.language : 'en';
  window.globalParams = window.spaParams.global[lang];
  return window.globalParams.pagination;
}

const renderFirstOrPrevLink = (pageIndex, pageCount, size, title, linkLabel) => {
  const paginationJcr = getPaginationJcr();
  let disabled = '';
  const previousTitle = `${size} ${paginationJcr.results} ${title ? `${paginationJcr.for} ${title}` : ''}`;
  const previousDisable = `${paginationJcr.results} ${title ? `${paginationJcr.for} ${title}` : ''}`;
  if (pageIndex === 0 && pageCount > 0) {
    disabled = 'disabled';
  }
  const cssModifier = (linkLabel === paginationJcr.first) ? 'first' : 'previous';
  return `
    <button
      type="button"
      class="${ROOT_CSS_CLASS}-btn ${ROOT_CSS_CLASS}-btn--${cssModifier}"
      data-goto="${linkLabel === paginationJcr.first ? 0 : (pageIndex - 1)}"
      ${disabled}
    >
      ${linkLabel}
      <span class="ada-hidden">${disabled ? previousDisable : previousTitle}</span>
    </button>
  `;
};

const renderNextOrLastLink = (pageIndex, pageCount, size, title, linkLabel) => {
  const paginationJcr = getPaginationJcr();
  let disabled = '';
  const nextTitle = `${size} ${paginationJcr.results} ${title ? `${paginationJcr.for} ${title}` : ''}`;
  const nextDisable = `${size} ${paginationJcr.results} ${title ? `${paginationJcr.for} ${title}` : ''}`;
  if (pageIndex === (pageCount - 1) && pageCount > 0) {
    disabled = 'disabled';
  }
  const cssModifier = (linkLabel === paginationJcr.next) ? 'next' : 'last';
  return `
    <button
      type="button"
      class="${ROOT_CSS_CLASS}-btn ${ROOT_CSS_CLASS}-btn--${cssModifier}"
      data-goto="${linkLabel === paginationJcr.last ? (pageCount - 1) : (pageIndex + 1)}" ${disabled}
    >
      ${linkLabel}
      <span class="ada-hidden">${disabled ? nextTitle : nextDisable}</span>
    </button>
  `;
};

const renderPaginationDropdown = (config, dropdown, label) => {
  let optionsString = '';
  let selectField = '';
  if (dropdown === 'page-size') {
    for (let optionval = 0; optionval < config.sizeList.length; optionval++) {
      optionsString += `<option data-val="${config.sizeList[optionval]}" ${(config.sizeList[optionval] === config.size ? 'selected' : '')}> ${config.sizeList[optionval]}</option>`;
    }
  } else if (dropdown === 'page-list') {
    for (let optionval = 1; optionval <= config.length; optionval++) {
      optionsString += `<option data-val="${optionval}" ${(optionval === config.index + 1 ? 'selected' : '')}> ${optionval}</option>`;
    }
  }
  selectField = `
    <select aria-label = "${label}" class= "${ROOT_CSS_CLASS}-${dropdown} ${ROOT_CSS_CLASS}-btn--${dropdown}">
      ${optionsString}
    </select>`;
  return selectField;
};

const renderShowMoreLink = (config, linkLabel) => {
  const { index, length } = config;
  let disabled = '';
  let adaMessage = '';
  if (index === (length - 1) && length > 0) {
    disabled = 'disabled';
  }
  if (index !== 0) {
    adaMessage = `${config.adaText.firstPhrase} ${config.size} ${config.adaText.lastPhrase}`;
  }
  const paginationJcr = getPaginationJcr();
  return `
    <span class="ada-hidden" id="${config.domContainer}showMoreMsg" role="alert">
      ${adaMessage}
    </span>
    <button
      type="button"
      class="${ROOT_CSS_CLASS}-btn ${ROOT_CSS_CLASS}-btn--load-more"
      data-goto="${index + 1}" ${disabled}
    >
      <span aria-hidden="true" class="${ROOT_CSS_CLASS}-btn--show-more">
        ${linkLabel}
      </span>
      <span class="ada-hidden">
        ${paginationJcr.showingNext} ${config.size} ${paginationJcr.of} ${config.title}
      </span>
      <div class="sparta-spinner--placeholder"></div>
    </button>
  `;
};

const renderBasicPagination = (config) => {
  const {
    index,
    length,
    size,
    title,
  } = config;

  let markup = '';
  if (length > 0) {
    const paginationJcr = getPaginationJcr();
    markup = `
      <nav class="${ROOT_CSS_CLASS} ${ROOT_CSS_CLASS}--align-${config.align}">
        <ul>
          <li>${renderFirstOrPrevLink(index, length, size, title, paginationJcr.first)}</li>
          <li>${renderFirstOrPrevLink(index, length, size, title, paginationJcr.previous)}</li>
          <li>${renderNextOrLastLink(index, length, size, title, paginationJcr.next)}</li>
          <li>${renderNextOrLastLink(index, length, size, title, paginationJcr.last)}</li>
        </ul>
      </nav>
    `;
  }
  return markup;
};

const renderAdvancedPagination = (config) => {
  const {
    index,
    length,
    size,
    title,
    totalRecords,
    allowPageSizeChange,
    align,
  } = config;

  if (length <= 0) {
    return '';
  }

  const pageTitle = `${title ? `for ${title}` : ''}`;

  const pageFrom = (index === 0 && length > 0 ? 1 : (index * size) + 1);
  let pageTo = (index + 1) * size;
  if (index === (length - 1) && length > 0) {
    pageTo = totalRecords;
  }

  const paginationJcr = getPaginationJcr();
  const paginationLabel = `
    <li class="${ROOT_CSS_CLASS}-align-frompagedata">
      ${paginationJcr.showing} ${pageFrom}
      <span aria-hidden="true">-</span> <span class="ada-hidden">${paginationJcr.to}</span>
      ${pageTo} ${paginationJcr.of} ${totalRecords}
      <span class="ada-hidden">${paginationJcr.results} ${title ? `${paginationJcr.for} ${title}` : ''}</span>
    </li>
  `;

  let pageSizeElements = '';
  if (allowPageSizeChange && totalRecords > size) {
    pageSizeElements = `
      <li class="${ROOT_CSS_CLASS}-align-page-size-list">
        <span aria-hidden="true">${paginationJcr.display}</span>
        ${renderPaginationDropdown(config, 'page-size', `${paginationJcr.selectNumberOfResults} ${pageTitle}`)}
        <span aria-hidden="true">${paginationJcr.perPage}</span>
      </li>
    `;
  } else {
    pageSizeElements = `<li class="${ROOT_CSS_CLASS}-align-page-size-list"></li>`;
  }

  let pageNavigation = '';
  if (totalRecords > size) {
    pageNavigation = `
      <li
        class="${ROOT_CSS_CLASS}-align-previous">
        ${renderFirstOrPrevLink(index, length, size, title, paginationJcr.previous)}
      </li>
      <li
        class="${ROOT_CSS_CLASS}-align-pagecountlist">
        ${renderPaginationDropdown(config, 'page-list', `${paginationJcr.selectPageNumber} ${pageTitle}`)}
      </li>
      <li
        class="${ROOT_CSS_CLASS}-align-next">
        ${renderNextOrLastLink(index, length, size, title, paginationJcr.next)}
      </li>
    `;
  }

  return `
    <nav class="${ROOT_CSS_CLASS} ${ROOT_CSS_CLASS}--align-${align}">
      <ul class="${ROOT_CSS_CLASS}-advanced pagination-left-border-li">
        ${paginationLabel}
        ${pageSizeElements}
        ${pageNavigation}
      </ul>
    </nav>
  `;
};

const renderProgressivePagination = (config) => {
  const { length, title } = config;
  let markup = '';
  if (length > 0) {
    const paginationJcr = getPaginationJcr();
    markup = `
      <nav class="${ROOT_CSS_CLASS} ${ROOT_CSS_CLASS}--align-center" aria-label="${title}">
        <ul>
          <li>${renderShowMoreLink(config, paginationJcr.showMoreRows)}</li>
        </ul>
      </nav>
    `;
  }
  return markup;
};

const paginationConfiguration = (options, config) => {
  const paginationOptions = { ...options };
  if (config.title) {
    paginationOptions.title = config.title;
  }
  if (typeof config.data !== 'function') {
    paginationOptions.totalRecords = config.totalRecords;
  }
  const getPageCount = () => {
    let count = 0;
    if (config.totalRecords > 0
      && options && options.size > 0) {
      count = Math.ceil(config.totalRecords / options.size);
    } else {
      count = options.totalRecords;
    }
    return count;
  };
  paginationOptions.length = getPageCount();
  return paginationOptions;
};

const helpers = {





  paginationHelper: function renderPagination(config) {
    const options = { ...DEFAULTS.pagination, ...config };
    if (!config || !options) {
      throw new Error('No pagination configuration provided.');
    }
    options.id = options.id || `spaPagination${Date.now()}`;
    const pageConfig = paginationConfiguration(options, config);
    let markup = '';
    if (pageConfig) {
      if (pageConfig.style === 'basic') {
        markup = renderBasicPagination(pageConfig);
      } else if (pageConfig.style === 'advanced') {
        markup = renderAdvancedPagination(pageConfig);
      } else if (pageConfig.style === 'progressive') {
        markup = renderProgressivePagination(pageConfig);
      }
    }
    return new Handlebars.SafeString(markup);
  },
};




class paginationHelper {





  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }






  static render(config) {
    return helpers.paginationHelper(config);
  }





  static getPaginationDefaults() {
    return DEFAULTS.pagination;
  }





  static getPaginationEventList() {
    return paginationEventsClassList;
  }
}

module.exports = paginationHelper;
